import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { Toaster, Content, Container, Frame } from '@kinesis/bungle';
import { SettingsMenu } from '@/components/settings-menu';
import {
  useListOrganisationsQuery,
  organisationsSelector,
} from '@/api/organisation';
import { useMeQuery } from '@/api/user';
import { useSettingsSelection } from '@/hooks/use-settings-selection';

const Settings = () => {
  const selection = useSettingsSelection();
  useListOrganisationsQuery();
  const organisations = useSelector(organisationsSelector);
  const { data: me } = useMeQuery();
  // A membership's editor permission is passport's `editor` relation on the
  // organisation, which is what editor-only settings are gated on.
  const menuOrganisations = useMemo(
    () =>
      organisations.map(({ id, name }) => ({
        id,
        name,
        editor:
          me?.memberships.find(({ organisationId }) => organisationId === id)
            ?.permissions.editor ?? false,
      })),
    [organisations, me],
  );

  return (
    <Container>
      <Toaster id='globalTop' placement='top' />
      <Frame borderRight sizing='fit-content'>
        <Content width={304} padding='medium' minHeight='100%'>
          <SettingsMenu
            organisations={menuOrganisations}
            selection={selection}
          />
        </Content>
      </Frame>
      <Frame>
        <Outlet />
      </Frame>
    </Container>
  );
};

export { Settings };
